// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getUserLeaveRequestAPI } from "../Apis/leaveApi";
import { leaveReducer } from "../Reducer/leaveReducer";

const initialStatusCounts = {
  total: 0,
  approved: 0,
  rejected: 0,
  cancelled: 0,
};

const initialState = {
  userLeaves: [],
  pagination: {
    currentPage: 1,
    pageSize: 12,
    totalData: 0,
    totalPages: 1,
  },
  statusCounts: initialStatusCounts,
  isLeavesUpdated: false,
  statusFilter: "",
  loading: false,
  error: null,
};

const leaveSlice = createSlice({
  name: "leave",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setLeaveStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
      state.pagination.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    leaveReducer(builder);
  },
});

export const { setCurrentPage, setLeaveStatusFilter } = leaveSlice.actions;
export default leaveSlice.reducer;
